import { useContent } from "@/context/ContentContext";
import { MapPin, Building2, Mail, ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";

export default function Contact() {
  const c = useContent();
  return (
    <div data-testid="contact-page">
      <div className="bg-[#2a0a12] text-white">
        <div className="max-w-7xl mx-auto px-6 py-14">
          <h1 className="font-serif text-4xl lg:text-5xl font-bold">{c.contact_title}</h1>
          <p className="mt-3 text-slate-300 max-w-2xl">{c.contact_subtitle}</p>
        </div>
      </div>
      <div className="max-w-4xl mx-auto px-6 py-14">
        <div className="rounded-xl border border-slate-200 bg-white p-8 lg:p-10">
          <h2 className="font-serif text-2xl text-slate-900 mb-6">{c.contact_office_heading}</h2>
          <div className="flex gap-4 mb-5">
            <Building2 className="h-6 w-6 text-[#800020] shrink-0" />
            <p className="font-medium text-slate-900" data-testid="contact-company">{c.contact_company}</p>
          </div>
          <div className="flex gap-4 mb-5">
            <MapPin className="h-6 w-6 text-[#800020] shrink-0" />
            <address className="not-italic text-slate-600 leading-relaxed whitespace-pre-line" data-testid="contact-address">{c.contact_address}</address>
          </div>
          <div className="flex gap-4">
            <Mail className="h-6 w-6 text-[#800020] shrink-0" />
            <a href={`mailto:${c.contact_email}`} className="text-slate-600 hover:text-[#800020]" data-testid="contact-email">{c.contact_email}</a>
          </div>

          <div className="mt-8 pt-8 border-t border-slate-100">
            <p className="text-slate-600">Interested in listing your boarding school with us?</p>
            <Link to="/list-your-school/listing-questionnaire" className="mt-4 inline-flex items-center gap-2 px-6 py-3 rounded-full bg-[#800020] hover:bg-[#660019] text-white font-medium transition-colors" data-testid="contact-questionnaire-cta">
              Fill the Listing Questionnaire <ArrowRight className="h-4 w-4" />
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}
